import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";

type Props = {
	visible: boolean;
};

export const TaskStepConnector: FC<Props> = ({ visible }) => {
	const { activity } = useTheme();

	return (
		<Stack
			flex={1}
			minHeight={activity.stepTimeline.connectorMinHeight}
			borderLeft={visible ? 1 : 0}
			borderColor="grey.300"
		/>
	);
};
